<template>
    <div v-if="sapProfile==true" style="overflow-x:auto !important">
        <div style="overflow:auto">
            <div>
                <div v-if="selectedMotorId!=null">
                    <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3427')}}</div>
                    <div class="ZAfont_family ZAfont_size" v-if="selectedMotorId!=null" style="display: grid; grid-template-columns: 1fr 1fr 2fr; grid-column-gap: 10px;">
                        <div style="margin-right:10px">{{$t('1098')}}:</div>
                        <div>
                            <span>{{selectedMotorId}}</span>
                            <span v-if="motorSelection!=null&&motorSelection.length>1" style="margin-left:10px; margin-bottom:0px; text-align:left">
                                <a @click.prevent="showModalInputSelection('motor')" class="ZAfont_family ZAfont_size" href="#">{{$t('3182')}}</a>
                            </span>
                        </div>
                    </div>
                    <div class="ZAfont_family ZAfont_size" v-if="selectedTractionSheaveId!=null" style="display: grid; grid-template-columns: 1fr 1fr 2fr; grid-column-gap: 10px;">
                        <div style="margin-right:10px">{{$t('1301')}}:</div>
                        <div>
                            <span>{{selectedTractionSheaveId}}</span>
                            <span v-if="tractionSheaveSelection!=null&&tractionSheaveSelection.length>1" style="margin-left:10px; margin-bottom:0px; text-align:left">
                                <a @click.prevent="showModalInputSelection('tractionSheave')" class="ZAfont_family ZAfont_size" href="#">{{$t('3182')}}</a>
                            </span>
                        </div>
                    </div>
                    <div v-if="brakePartnumber!=null" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 2fr; grid-column-gap: 10px;">
                        <div style="margin-right:10px">{{$t('1396')}}:</div>
                        <div>{{brakePartnumber}}</div>
                    </div>
                    <div v-if="encoderPartnumber!=null" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 2fr; grid-column-gap: 10px;">
                        <div style="margin-right:10px">{{$t('3075')}}:</div>
                        <div>{{encoderPartnumber}}</div>
                    </div>
                    <hr />
                </div>
                <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3457')}}</div>
                <div class="ZAfont_family ZAfont_size" v-if="motorManualDataSelected!=null&&motorManualDataSelected.mfbtyp!=null" style="display: grid; grid-template-columns: 1fr 1fr 2fr; grid-column-gap: 10px;">
                    <div style="margin-right:10px">{{$t('298')}}:</div>
                    <div>
                        <span v-if="motorManualDataSelected.mfbtyp!=null && motorManualDataSelected.mfbtyp.useTextKey==false">{{motorManualDataSelected.mfbtyp.textUI}}</span>
                        <span v-if="motorManualDataSelected.mfbtyp!=null && motorManualDataSelected.mfbtyp.useTextKey==true">{{$t(motorManualDataSelected.mfbtyp.textKey)}}</span>
                    </div>
                </div>
                <div style="display: grid; grid-template-columns: 1fr 1fr 2fr; grid-column-gap: 10px; margin-top: 20px">
                    <div>
                        <div class="ZAfont_family ZAfont_size">{{$t('3457')}}</div>
                    </div>
                    <div v-if="motorIP_Selection.length==0 || motorIP_Selection.length>4">
                        <select v-model="selectedMotorIP" class="my_select" style="width:100%">
                            <option value="null" hidden>{{$t('3174')}}</option>
                            <option value="" hidden>{{$t('3174')}}</option>
                            <option v-for="motorIP in motorIP_Selection" v-bind:value="motorIP">{{motorIP.text}}</option>
                        </select>
                    </div>
                    <div v-if="motorIP_Selection.length>0 && motorIP_Selection.length<=4">
                        <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedMotorIP==null, my_input_background_color_at_validInput:selectedMotorIP!=null}">
                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                <li v-for="motorIP in motorIP_Selection">
                                    <div>
                                        <input type="checkbox" @input="change_Selected_atElementOf_motorIP(motorIP)" v-bind:checked="motorIP.selected" v-bind:disabled="motorIP.selected" />
                                        <span style="margin-left:10px">{{motorIP.text}}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <hr />
                <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px;">
                    <div>
                        <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3533')}}</div>
                        <div v-if="ropeGuardDetailsSelected!=null" style="display: grid; grid-template-columns: 3fr 1fr; grid-column-gap: 10px;">
                            <div style="vertical-align: central">
                                <div class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 2fr 1fr; grid-column-gap: 10px; margin-top: 80px">
                                    <div style="margin-right:10px">{{$t('1416')}}: </div>
                                    <div>
                                        <span v-if="ropeGuardDetailsSelected.motorPosition!=null && ropeGuardDetailsSelected.motorPosition.useTextKey==false">{{ropeGuardDetailsSelected.motorPosition.textUI}}</span>
                                        <span v-if="ropeGuardDetailsSelected.motorPosition!=null && ropeGuardDetailsSelected.motorPosition.useTextKey==true">{{$t(ropeGuardDetailsSelected.motorPosition.textKey)}}</span>
                                    </div>
                                </div>
                                <div class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 2fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div style="margin-right:10px">{{$t('3536')}}: </div>
                                    <div>
                                        <span v-if="ropeGuardDetailsSelected.ropePull!=null && ropeGuardDetailsSelected.ropePull.useTextKey==false">{{ropeGuardDetailsSelected.ropePull.textUI}}</span>
                                        <span v-if="ropeGuardDetailsSelected.ropePull!=null && ropeGuardDetailsSelected.ropePull.useTextKey==true">{{$t(ropeGuardDetailsSelected.ropePull.textKey)}}</span>
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; justify-content: center; align-items: center ">
                                <span v-if="ropeGuardDetailsSelected.imagePath!=null">
                                    <Images :imageFilePath="ropeGuardDetailsSelected.imagePath" :maxImageHeight="200" :maxImageWidth="200"></Images>
                                </span>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3533')}} {{$t('3395')}}:</div>
                            </div>
                            <div v-if="deliverRopeSelection != null&&(deliverRopeSelection.length==0||deliverRopeSelection.length>4)">
                                <select v-model="selectedDeliverRope" class="my_select" style="width:100%" v-bind:disabled="deliverRopeSelectionDisabled==true" v-bind:class="{my_input_border_at_invalidInput: selectedDeliverRope==null, my_input_background_color_at_validInput:selectedDeliverRope!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="deliverRope in deliverRopeSelection" v-bind:value="sheaveProfile">{{deliverRope.text.textUI}}</option>
                                </select>
                            </div>
                            <div v-if="deliverRopeSelection != null&&deliverRopeSelection.length>0&&deliverRopeSelection.length<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedDeliverRope==null, my_input_background_color_at_validInput:selectedDeliverRope!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="deliverRope in deliverRopeSelection">
                                            <div>
                                                <input type="checkbox" @input="change_Selected_atElementOf_deliverRope(deliverRope)" v-bind:checked="deliverRope.selected" v-bind:disabled="deliverRope.selected || deliverRopeSelectionDisabled==true" />
                                                <span v-if="deliverRope.text.useTextKey == false" style="margin-left:10px">{{deliverRope.text.textUI}}</span>
                                                <span v-if="deliverRope.text.useTextKey == true" style="margin-left:10px">{{$t(deliverRope.text.textKey)}}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="showAltRopeGuard==null||showAltRopeGuard===false">
                            <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                <div>
                                    <div class="ZAfont_family ZAfont_size">{{$t('3534')}}:</div>
                                </div>
                                <div v-if="tractionSheaveCoverSelection.length==0 || tractionSheaveCoverSelection.length>4">
                                    <select v-model="selectedTractionSheaveCover" class="my_select" style="width:100%" v-bind:disabled="tractionSheaveCoverSelection.length || tractionSheaveCoverSelectionDisabled==true">
                                        <option v-for="tractionSheaveCover in tractionSheaveCoverSelection" v-bind:value="tractionSheaveCover">{{tractionSheaveCover.text.text}}</option>
                                    </select>
                                </div>
                                <div v-if="tractionSheaveCoverSelection.length>0 && tractionSheaveCoverSelection.length<=4">
                                    <div style="display: grid;">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="tractionSheaveCover in tractionSheaveCoverSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_tractionSheaveCover(tractionSheaveCover)" v-bind:checked="tractionSheaveCover.selected" v-bind:disabled="tractionSheaveCover.selected || tractionSheaveCoverSelectionDisabled==true" />
                                                <span style="margin-left:10px">{{tractionSheaveCover.text.text}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                <div>
                                    <div class="ZAfont_family ZAfont_size">{{$t('3537')}}:</div>
                                </div>
                                <div v-if="adjustabilitySelection.length>=0">
                                    <select v-model="selectedAdjustability" class="my_select" style="width:100%" v-bind:disabled="adjustabilitySelection.length==0">
                                        <option v-for="adjustability in adjustabilitySelection" v-bind:value="adjustability">{{adjustability.text.textUI}}</option>
                                    </select>
                                    <div v-if="selectedAdjustabilityMessage===true&&ropeGuardDetailsSelected!=null&&ropeGuardDetailsSelected.usw!=null" class="ZAfont_family ZAfont_size" style="color:red">
                                        <span>{{$t('1289')}} {{$t('1404')}} {{ValueDecimalSeparator(ropeGuardDetailsSelected.usw)}}°</span>
                                    </div>
                                </div>
                                <!--<div v-if="adjustabilitySelection.length>0 && adjustabilitySelection.length<=4">
                                    <div style="display: grid;">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="adjustability in adjustabilitySelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_adjustability(adjustability)" v-bind:checked="adjustability.selected" v-bind:disabled="adjustability.selected" />
                                                <span style="margin-left:10px">{{adjustability.text.textUI}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>-->
                            </div>
                            <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                <div>
                                    <div class="ZAfont_family ZAfont_size">{{$t('3538')}}:</div>
                                </div>
                                <div v-if="thirdRopeGuardRequiredOnSite==false&&(thirdRopeGuardSelection.length==0||thirdRopeGuardSelection.length>4)">
                                    <select v-model="selectedThirdRopeGuard" class="my_select" style="width:100%" v-bind:disabled="thirdRopeGuardSelection.length==0">
                                        <option v-for="thirdRopeGuard in thirdRopeGuardSelection" v-bind:value="thirdRopeGuard">{{thirdRopeGuard.text.textUI}}</option>
                                    </select>
                                </div>
                                <div v-if="thirdRopeGuardRequiredOnSite==false&&thirdRopeGuardSelection.length>0&&thirdRopeGuardSelection.length<=4">
                                    <div style="display: grid;">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="thirdRopeGuard in thirdRopeGuardSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_thirdRopeGuard(thirdRopeGuard)" v-bind:checked="thirdRopeGuard.selected" v-bind:disabled="thirdRopeGuard.selected" />
                                                <span style="margin-left:10px">{{thirdRopeGuard.text.textUI}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div v-if="thirdRopeGuardRequiredOnSite!=null&&thirdRopeGuardRequiredOnSite==true">
                                    <div style="display: grid; color: red">
                                        <b class="ZAfont_family ZAfont_size">{{$t('3549')}}</b>
                                    </div>
                                </div>
                            </div>
                            <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                <div>
                                    <div class="ZAfont_family ZAfont_size">{{$t('3543')}}:</div>
                                </div>
                                <div v-if="ropeClampSelection.length==0 || ropeClampSelection.length>4">
                                    <select v-model="selectedRopeClamp" class="my_select" style="width:100%" v-bind:disabled="ropeClampSelection.length==0 || ropeClampSelectionDisabled">
                                        <option v-for="ropeClamp in ropeClampSelection" v-bind:value="ropeClamp">{{ropeClamp.text.textUI}}</option>
                                    </select>
                                </div>
                                <div v-if="ropeClampSelection.length>0 && ropeClampSelection.length<=4">
                                    <div style="display: grid;">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="ropeClamp in ropeClampSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_ropeClamp(ropeClamp)" v-bind:checked="ropeClamp.selected" v-bind:disabled="ropeClamp.selected || ropeClampSelectionDisabled" />
                                                <span style="margin-left:10px">{{ropeClamp.text.textUI}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                <div>
                                    <div class="ZAfont_family ZAfont_size">{{$t('3586')}}:</div>
                                </div>
                                <div v-if="rescueReturnDeviceSelection.length==0 || rescueReturnDeviceSelection.length>4">
                                    <select v-model="selectedRescueReturnDevice" class="my_select" style="width:100%" v-bind:disabled="rescueReturnDeviceSelection.length==0 || rescueReturnDeviceSelectionDisabled">
                                        <option v-for="rescueReturnDevice in rescueReturnDeviceSelection" v-bind:value="rescueReturnDevice">{{rescueReturnDevice.text.textUI}}</option>
                                    </select>
                                </div>
                                <div v-if="rescueReturnDeviceSelection.length>0 && rescueReturnDeviceSelection.length<=4">
                                    <div style="display: grid;">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="rescueReturnDevice in rescueReturnDeviceSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_rescueReturnDevice(rescueReturnDevice)" v-bind:checked="rescueReturnDevice.selected" v-bind:disabled="rescueReturnDevice.selected || rescueReturnDeviceSelectionDisabled" />
                                                <span style="margin-left:10px">{{rescueReturnDevice.text.textUI}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="showAltRopeGuard!=null&&showAltRopeGuard===true">
                            <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                <div></div>
                                <div class="ZAfont_family ZAfont_size" style="color:orangered;">
                                    <div class="my_fontWeight_600">{{$t('3725')}}</div>
                                </div>
                            </div>
                            <div style="margin-top: 50px">
                                <a @click.prevent="showModalRopeGuardSelection(true)" class="ZAfont_family ZAfont_size" href="#">{{$t('3726')}}</a>
                            </div>
                        </div>
                    </div>
                    <div v-if="showAltRopeGuard!=null&&showAltRopeGuard===true&&altRopeGuard!=null" style="margin-left: 10px; border-left: 1px solid rgba(0, 0, 21, 0.2)">
                        <div style="margin-left:20px">
                            <a @click.prevent="change_Selected_atElementOf_altRopeGuard" class="ZAfont_family ZAfont_size" href="#">{{$t('3290')}}</a>
                            <div class="ZAfont_family ZAfont_size" v-if="altRopeGuard!=null">
                                <div style="display: grid; grid-template-columns: 3fr 1fr; grid-column-gap: 10px;">
                                    <div>
                                        <div style="display: grid; grid-template-columns: 2fr 1fr; grid-column-gap: 10px; margin-top: 80px">
                                            <div class="ZAfont_family ZAfont_size">{{$t('1416')}}: </div>
                                            <div>{{altRopeGuard.fuesse.useTextKey?$t(altRopeGuard.fuesse.textKey):altRopeGuard.fuesse.textUI}}</div>
                                        </div>
                                        <div style="display: grid; grid-template-columns: 2fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                            <div class="ZAfont_family ZAfont_size">{{$t('3536')}}: </div>
                                            <div>{{altRopeGuard.seilab.useTextKey?$t(altRopeGuard.seilab.textKey):altRopeGuard.seilab.textUI}}</div>
                                        </div>
                                        <div style="display: grid; grid-template-columns: 2fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                            <div class="ZAfont_family ZAfont_size">{{$t('3537')}}: </div>
                                            <div>{{altRopeGuard.einst.useTextKey?$t(altRopeGuard.einst.textKey):altRopeGuard.einst.textUI}}</div>
                                        </div>
                                    </div>
                                    <div style="display: flex; justify-content: center; align-items: center ">
                                        <span v-if="altRopeGuard.imagePath!=null">
                                            <Images :imageFilePath="altRopeGuard.imagePath" :maxImageHeight="200" :maxImageWidth="200"></Images>
                                        </span>
                                    </div>
                                </div>
                                <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div class="ZAfont_family ZAfont_size">{{$t('3533')}}: </div>
                                    <div v-if="showAltLseilsSelection==true">
                                        <div style="display: grid;">
                                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                                <li v-for="lseils in altLseilsSelection" :key="lseils.text.code">
                                                    <input type="checkbox" @input="change_Selected_atElementOf_altLseils(lseils.text.code, $event)" v-bind:checked="Number(altLseilsSelectedCode) === Number(lseils.text.code)" v-bind:disabled="altLseilsSelectedCode!=null&&altLseilsSelectedCode>0" />
                                                    <span style="margin-left:10px">{{lseils.text.text}}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div v-if="showAltLseilsSelection==false">
                                        <span>{{$t('1407')}}</span>
                                    </div>
                                </div>
                                <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div class="ZAfont_family ZAfont_size">{{$t('3534')}}</div>
                                    <div v-if="showAltLtsabdSelection==true">
                                        <div style="display: grid;">
                                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                                <li v-for="ltsabd in altLtsabdSelection" :key="ltsabd.text.code">
                                                    <input type="checkbox" @input="change_Selected_atElementOf_altLtsabd(ltsabd.text.code, $event)" v-bind:checked="Number(altLtsabdSelectedCode) === Number(ltsabd.text.code)" v-bind:disabled="altRopeGuard!=null&&altRopeGuard.tnsabd!=null&&altLtsabdSelectedCode!=null&&altLtsabdSelectedCode>0" />
                                                    <span style="margin-left:10px">{{ltsabd.text.text}}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div v-if="showAltLtsabdSelection==false">
                                        <span>{{$t('1407')}}</span>
                                    </div>
                                </div>
                                <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div class="ZAfont_family ZAfont_size">{{$t('3543')}}: </div>
                                    <div v-if="showAltLtklemSelection==true">
                                        <div style="display: grid;">
                                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                                <li v-for="ltklem in altLtklemSelection" :key="ltklem.text.code">
                                                    <input type="checkbox" @input="change_Selected_atElementOf_altLtklem(ltklem.text.code, $event)" v-bind:checked="Number(altLtklemSelectedCode) === Number(ltklem.text.code)" />
                                                    <span style="margin-left:10px">{{ltklem.text.text}}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div v-if="showAltLtklemSelection==false">
                                        <span>{{$t('1407')}}</span>
                                    </div>
                                </div>
                                <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div class="ZAfont_family ZAfont_size">{{$t('3586')}}: </div>
                                    <div v-if="showAltLruevSelection==true">
                                        <div style="display: grid;">
                                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                                <li v-for="lruev in altLruevSelection" :key="lruev.text.code">
                                                    <input type="checkbox" @input="change_Selected_atElementOf_altLruev(lruev.text.code, $event)" v-bind:checked="Number(altLruevSelectedCode) === Number(lruev.text.code)" v-bind:disabled="altLtklemSelectedCode==null||altLtklemSelectedCode==0" />
                                                    <span style="margin-left:10px">{{lruev.text.text}}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div v-if="showAltLruevSelection==false">
                                        <span>{{$t('1407')}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div style="display: grid; grid-template-columns: 1fr 1fr 2fr; grid-column-gap: 10px; margin-top: 20px">
                    <div>
                        <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3441')}}</div>
                    </div>
                    <div class="ZAfont_family ZAfont_size" v-if="brakeConnectionSelection.length==0" style="color:red">{{$t('3621')}}</div>
                    <div v-if="brakeConnectionSelection.length>4">
                        <select v-model="selectedBrakeConnection" class="my_select" style="width:100%">
                            <option value="null" hidden>{{$t('3174')}}</option>
                            <option value="" hidden>{{$t('3174')}}</option>
                            <option v-for="brakeConnection in brakeConnectionSelection" v-bind:value="brakeConnection">{{brakeConnection.textUI}} | {{brakeConnection.additionalText}}</option>
                        </select>
                    </div>
                    <div v-if="brakeConnectionSelection.length>0 && brakeConnectionSelection.length<=4">
                        <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedBrakeConnection==null, my_input_background_color_at_validInput:selectedBrakeConnection!=null}">
                            <ul class="my_inputCheckbox2 ZAfont_family ZAfont_size">
                                <li v-for="brakeConnection in brakeConnectionSelection">
                                    <div>
                                        <input type="checkbox" @input="change_Selected_atElementOf_brakeConnection(brakeConnection)" v-bind:checked="brakeConnection.selected" v-bind:disabled="brakeConnection.selected" />
                                        <span v-if="brakeConnection.textKey==null" style="margin-left:10px">{{brakeConnection.textUI}}</span>
                                        <span v-if="brakeConnection.textKey!=null" style="margin-left:10px">{{$t(brakeConnection.textKey)}}</span>
                                        <span v-if="brakeConnection.additionalText!=null"> | {{brakeConnection.additionalText}}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <hr />
                <div v-if="bowdenwireDeliverSelection.length>0">
                    <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3442')}}</div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 2fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3442')}}</div>
                        </div>
                        <div class="ZAfont_family ZAfont_size" v-if="bowdenwireDeliverSelection.length==0">{{$t('3621')}}</div>
                        <div v-if="bowdenwireDeliverSelection.length>4">
                            <select v-model="selectedBowdenwireDeliver" class="my_select" style="width:100%">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="bowdenwireDeliver in bowdenwireDeliverSelection" v-bind:value="bowdenwireDeliver">{{bowdenwireDeliver.text.textUI}}</option>
                            </select>
                        </div>
                        <div v-if="bowdenwireDeliverSelection.length>0 && bowdenwireDeliverSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedBowdenwireDeliver==null, my_input_background_color_at_validInput:selectedBowdenwireDeliver!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="bowdenwireDeliver in bowdenwireDeliverSelection">
                                        <div>
                                            <input type="checkbox" @input="change_Selected_atElementOf_bowdenwireDeliver(bowdenwireDeliver)" v-bind:checked="bowdenwireDeliver.selected" v-bind:disabled="bowdenwireDeliver.selected" />
                                            <span v-if="bowdenwireDeliver.text.textKey==null" style="margin-left:10px">{{bowdenwireDeliver.text.textUI}}</span>
                                            <span v-if="bowdenwireDeliver.text.textKey!=null" style="margin-left:10px">{{$t(bowdenwireDeliver.text.textKey)}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-if="showBowdenwireDetails===true" style="display: grid; grid-template-columns: 1fr 1fr 2fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3443')}}</div>
                        </div>
                        <div v-if="bowdenwireDetailsSelection.length>4">
                            <select v-model="selectedBowedenwireDetails" class="my_select" style="width:100%">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="bowdenwireDetails in bowdenwireDetailsSelection" v-bind:value="bowdenwireDetails">{{bowdenwireDetails.length}}</option>
                            </select>
                        </div>
                        <div v-if="bowdenwireDetailsSelection.length>0 && bowdenwireDetailsSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedBowdenwireDetails==null||selectedBowdenwireDetails.selected==null, my_input_background_color_at_validInput:selectedBowdenwireDetails==null||selectedBowdenwireDetails.selected!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="bowdenwireDetails in bowdenwireDetailsSelection">
                                        <div>
                                            <input type="checkbox" @input="change_Selected_atElementOf_bowdenwireDetails(bowdenwireDetails)" v-bind:checked="bowdenwireDetails.selected" v-bind:disabled="bowdenwireDetails.selected" />
                                            <span style="margin-left:10px">{{bowdenwireDetails.length}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
                <div v-if="rotatedBrakeReleaseSelection.length>0" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                    <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px;">
                        <div>
                            <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3714')}}</div>
                        </div>
                        <div v-if="rotatedBrakeReleaseSelection.length>4">
                            <select v-model="selectedRotatedBrakeRelease" class="my_select" style="width:100%">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="rotatedBrakeRelease in rotatedBrakeReleaseSelection" v-bind:value="rotatedBrakeRelease">{{rotatedBrakeRelease.value}}&deg;</option>
                            </select>
                        </div>
                        <div v-if="rotatedBrakeReleaseSelection.length>0 && rotatedBrakeReleaseSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedBrakeConnection==null, my_input_background_color_at_validInput:selectedBrakeConnection!=null}">
                                <ul class="my_inputCheckbox2 ZAfont_family ZAfont_size">
                                    <li v-for="rotatedBrakeRelease in rotatedBrakeReleaseSelection">
                                        <div>
                                            <input type="checkbox" @input="change_Selected_atElementOf_rotatedBrakeRelease(rotatedBrakeRelease)" v-bind:checked="rotatedBrakeRelease.selected" v-bind:disabled="rotatedBrakeRelease.selected" />
                                            <span style="margin-left:10px">{{rotatedBrakeRelease.value}}&deg;</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style="display: flex; justify-content: center; align-items: center ">
                            <img src="../../../../public/img/ProductImages/RotatedBrake.png" style="width: 250px" />
                        </div>
                    </div>
                </div>
            </div>
            <InputSelectionModal v-if="showInputSelectionModal==true" :version="'zlw'"></InputSelectionModal>
            <RopeGuardSelectionModal v-if="showRopeGuardSelectionModal==true"></RopeGuardSelectionModal>
            <div class="my_btn_nextConfigurationStep_position">
                <button @click="closeAddOnPartModal(false)" class="btn my_btn_standard" style="margin-right:5px">{{$t('3237')}}</button>
                <button @click="closeAddOnPartModal(true)" class="btn my_btn_standard" v-bind:disabled="continueButton_Disabled===true">{{$t('1023')}}</button>
            </div>

        </div>
    </div>
</template>


<script>
    import router from '../../../router';
    import { configurations } from '../../../store/configurations.module';
    import { inputsManual } from '../../../store/inputsManual.module';
    import { ropeGuardManual } from '../../../store/ropeGuardManual.module';
    import { driveTechnologiesManual } from '../../../store/driveTechnologiesManual.module';
    import InvalidityReasons from '../../dataValidation/InvalidityReasons';
    import LoaderIcon from '../../loader/LoaderIcon';
    import axios from 'axios';
    import Images from '../../configuration/Images';
    import InputSelectionModal from '../../configuration/manualSteps/InputSelectionModal';
    import RopeGuardSelectionModal from '../../configuration/manualSteps/RopeGuardSelectionModal';

    export default {
        name: 'AddOnPartModal',

        components: {
            InvalidityReasons,
            LoaderIcon,
            Images,
            InputSelectionModal,
            RopeGuardSelectionModal,
        },
        computed: {
            sapProfile: {
                get() {
                    return this.$store.state.configurations.sap;
                },
            },
            motorManualDataSelected: {
                get() {
                    if (this.$store.state.inputsManual.motorManualData != null && this.$store.state.inputsManual.motorManualData.hasOwnProperty('details') && this.$store.state.inputsManual.motorManualData.details.hasOwnProperty('mN_MOT')) {
                        return this.$store.state.inputsManual.motorManualData;
                    }
                    return null;
                }
            },
            showInputSelectionModal: {
                get() {
                    return this.$store.state.inputsManual.showInputSelectionModal;
                }
            },
            showRopeGuardSelectionModal: {
                get() {
                    return this.$store.state.inputsManual.showRopeGuardSelectionModal;
                }
            },
            motorSelection: {
                get() {
                    return this.$store.state.inputsManual.motordetailsSelection;
                }
            },
            selectedMotorId: {
                get() {
                    const selected = this.motorSelection != null ? this.motorSelection.find(i => i.selected === true) : null;
                    return selected != null ? selected.id : null;
                }
            },
            tractionSheaveSelection: {
                get() {
                    return this.$store.state.inputsManual.tractionSheavedetailsSelection;
                }
            },
            selectedTractionSheaveId: {
                get() {
                    const selected = this.motorSelection != null ? this.tractionSheaveSelection.find(i => i.selected === true) : null;
                    return selected != null ? selected.id : null;
                }
            },
            brakePartnumber: {
                get() {
                    return this.$store.state.inputsManual.brakePartnumber;
                }
            },
            encoderPartnumber: {
                get() {
                    return this.$store.state.inputsManual.encoderPartnumber;
                }
            },
            ropeGuardDetailsSelected: {
                get() {
                    return this.$store.state.ropeGuardManual.ropeGuardDetailsSelected;
                },
            },
            adjustabilitySelection: {
                get() {
                    return this.$store.state.ropeGuardManual.adjustabilitySelection;
                },
            },
            selectedAdjustability: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedAdjustability'];
                },
                set(value) {
                    this.change_Selected_atElementOf_adjustability(value);
                }
            },
            selectedAdjustabilityMessage: {
                get() {
                    return this.selectedAdjustability != null && this.selectedAdjustability.valid === false ? true : false;
                },
            },
            thirdRopeGuardSelection: {
                get() {
                    return this.$store.state.ropeGuardManual.thirdRopeGuardSelection;
                },
            },
            selectedThirdRopeGuard: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedThirdRopeGuard'];
                },
                set(value) {
                    this.change_Selected_atElementOf_thirdRopeGuard(value);
                }
            },
            thirdRopeGuardRequiredOnSite: {
                get() {
                    return this.selectedThirdRopeGuard != null && this.selectedThirdRopeGuard.hasOwnProperty('thirdRopeGuardRequiredOnSite')
                        ? this.selectedThirdRopeGuard.thirdRopeGuardRequiredOnSite
                        : null;
                }
            },
            deliverRopeSelection: {
                get() {
                    return this.$store.state.ropeGuardManual.deliverRopeSelection;
                },
            },
            selectedDeliverRope: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedDeliverRope'];
                },
                set(value) {
                    this.change_Selected_atElementOf_deliverRope(value);
                }
            },
            showDeliverRope: {
                get() {
                    return !Array.isArray(this.deliverRopeSelection) ||
                        !this.deliverRopeSelection.some(i =>
                            i.selected === true &&
                            i.text &&
                            i.text.code === 0
                        );
                },
                set(value) {
                    this.change_Selected_atElementOf_deliverRope(value);
                }
            },
            deliverRopeSelectionDisabled: {
                get() {
                    return false; //this.$store.getters['ropeGuardManual/deliverRopeSelectionDisabled'];
                },
            },
            showAltRopeGuard: {
                get() {
                    //return (this.deliverRopeSelection != null && this.deliverRopeSelection.length == 1 && this.selectedDeliverRope != null && this.selectedDeliverRope.text.code == 0) ? true : false;
                    return false;
                }
            },
            tractionSheaveCover_Selection: {
                get() {
                    return this.$store.state.ropeGuardManual.tractionSheaveCoverSelection;
                },
            },

            tractionSheaveCoverSelection: {
                get() {
                    const value = this.tractionSheaveCover_Selection;
                    return value
                        && Object.prototype.hasOwnProperty.call(value, 'selection')
                        && Array.isArray(value.selection)
                        ? value.selection
                        : [];
                },
            },
            selectedTractionSheaveCover: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedTractionSheaveCover'];
                },
                set(value) {
                    this.change_Selected_atElementOf_tractionSheaveCover(value);
                }
            },
            tractionSheaveCoverSelectionDisabled: {
                get() {
                    return false; //this.$store.getters['ropeGuardManual/tractionSheaveCoverDisabled'];
                },
            },
            ropeClampSelection: {
                get() {
                    const value = this.$store.state.ropeGuardManual.ropeClampSelection;
                    return value &&
                        Object.prototype.hasOwnProperty.call(value, 'selection') &&
                        Array.isArray(value.selection)
                        ? value.selection
                        : [];
                },
            },
            selectedRopeClamp: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedRopeClamp'];
                },
                set(value) {
                    this.change_Selected_atElementOf_ropeClamp(value);
                }
            },
            ropeClampSelectionDisabled: {
                get() {
                    return this.$store.state.ropeGuardManual.ropeClampSelection != null && this.$store.state.ropeGuardManual.ropeClampSelection.hasOwnProperty('disabled')
                        ? this.$store.state.ropeGuardManual.ropeClampSelection.disabled
                        : true;
                },
            },
            rescueReturnDeviceSelection: {
                get() {
                    return this.$store.state.ropeGuardManual.rescueReturnDeviceSelection != null
                        && this.$store.state.ropeGuardManual.rescueReturnDeviceSelection.hasOwnProperty('selection')
                        && Array.isArray(this.$store.state.ropeGuardManual.rescueReturnDeviceSelection.selection)
                        ? this.$store.state.ropeGuardManual.rescueReturnDeviceSelection.selection
                        : [];
                },
            },
            selectedRescueReturnDevice: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedRescueReturnDevice'];
                },
                set(value) {
                    this.change_Selected_atElementOf_rescueReturnDevice(value);
                }
            },
            rescueReturnDeviceSelectionDisabled: {
                get() {
                    return (this.$store.state.ropeGuardManual.rescueReturnDeviceSelection != null && this.$store.state.ropeGuardManual.rescueReturnDeviceSelection.hasOwnProperty('disabled')) ? this.$store.state.ropeGuardManual.rescueReturnDeviceSelection.disabled : true;
                },
            },
            altRopeGuard: {
                get() {
                    return (this.$store.state.ropeGuardManual.altRopeGuard != null && this.$store.state.ropeGuardManual.altRopeGuard != undefined && this.$store.state.ropeGuardManual.altRopeGuard.hasOwnProperty('id')) ? this.$store.state.ropeGuardManual.altRopeGuard : null;
                }
            },
            showAltLseilsSelection: {
                get() {
                    return this.altRopeGuard != null && this.altRopeGuard.tnschu != null ? true : false;
                }
            },
            showAltLtsabdSelection: {
                get() {
                    return this.altRopeGuard != null && (this.altRopeGuard.tnabde != null || this.altRopeGuard.tnsabd) ? true : false;
                }
            },
            showAltLtklemSelection: {
                get() {
                    return this.altRopeGuard != null && (this.altRopeGuard.tnklem != null || this.altRopeGuard.tnklel) ? true : false;
                }
            },
            showAltLruevSelection: {
                get() {
                    return this.altRopeGuard != null && this.altRopeGuard.tnruev != null ? true : false;
                }
            },
            altLseilsSelection: {
                get() {
                    return this.$store.state.ropeGuardManual.altLseilsSelection;
                }
            },
            altLtsabdSelection: {
                get() {
                    return this.$store.state.ropeGuardManual.altLtsabdSelection;
                }
            },
            altLtklemSelection: {
                get() {
                    var _altLtklemSelection = this.$store.state.ropeGuardManual.altLtklemSelection;
                    if (!_altLtklemSelection.length) {
                        return [];
                    }

                    const code = (this.altRopeGuard != null && this.altRopeGuard.tnklel != null) ? 2 : 1;
                    return _altLtklemSelection.filter(i => i.text.code === code);
                }
            },
            altLruevSelection: {
                get() {
                    return this.$store.state.ropeGuardManual.altLruevSelection;
                }
            },
            altLseilsSelectedCode: {
                get() {
                    return this.$store.state.ropeGuardManual.altLseilsSelectedCode;
                }
            },
            altLtsabdSelectedCode: {
                get() {
                    return this.$store.state.ropeGuardManual.altLtsabdSelectedCode;
                }
            },
            altLtklemSelectedCode: {
                get() {
                    return this.$store.state.ropeGuardManual.altLtklemSelectedCode;
                }
            },
            altLruevSelectedCode: {
                get() {
                    return this.$store.state.ropeGuardManual.altLruevSelectedCode;
                }
            },
            motorIP_Selection: {
                get() {
                    return Array.isArray(this.$store.state.inputsManual.motorIP_Selection) ? this.$store.state.inputsManual.motorIP_Selection : [];
                },
            },
            selectedMotorIP: {
                get() {
                    if (this.$store.state.inputsManual.motorIP_Selection != null && Array.isArray(this.$store.state.inputsManual.motorIP_Selection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.inputsManual.motorIP_Selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.inputsManual.motorIP_Selection[firstIndex_whichMeetConditions];
                        }
                    }
                    return null;
                },
                set(value) {
                    this.change_Selected_atElementOf_motorIP(value);
                }
            },
            brakeConnectionSelection: {
                get() {
                    return Array.isArray(this.$store.state.inputsManual.brakeConnectionSelection) ? this.$store.state.inputsManual.brakeConnectionSelection : [];
                },
            },
            selectedBrakeConnection: {
                get() {
                    if (this.$store.state.inputsManual.brakeConnectionSelection != null && Array.isArray(this.$store.state.inputsManual.brakeConnectionSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.inputsManual.brakeConnectionSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.inputsManual.brakeConnectionSelection[firstIndex_whichMeetConditions];
                        }
                    }
                    return null;
                },
                set(value) {
                    this.change_Selected_atElementOf_brakeConnection(value);
                }
            },
            bowdenwireDeliverSelection: {
                get() {
                    return Array.isArray(this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection) ? this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection : [];
                },
            },
            selectedBowdenwireDeliver: {
                get() {
                    if (this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection[firstIndex_whichMeetConditions];
                        }
                    }
                    return null;
                },
                set(value) {
                    this.change_Selected_atElementOf_bowdenwireDeliver(value);
                }
            },
            showBowdenwireDetails:
            {
                get() {
                    if (this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection[firstIndex_whichMeetConditions].showDetails;
                        }
                    }
                    return false;
                },
            },
            bowdenwireDetailsSelection: {
                get() {
                    if (this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection)) {
                        return this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection;
                    }
                    return [];
                },
            },
            selectedBowdenwireDetails: {
                get() {
                    if (this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection[firstIndex_whichMeetConditions];
                        }
                    }
                    return null;
                },
                set(value) {
                    this.change_Selected_atElementOf_bowdenwireDetails(value);
                }
            },

            rotatedBrakeReleaseSelection: {
                get() {
                    return Array.isArray(this.$store.state.driveTechnologiesManual.rotatedBrakeReleaseSelection) ? this.$store.state.driveTechnologiesManual.rotatedBrakeReleaseSelection : [];
                },
            },
            selectedRotatedBrakeRelease: {
                get() {
                    if (this.$store.state.driveTechnologiesManual.rotatedBrakeReleaseSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.rotatedBrakeReleaseSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.driveTechnologiesManual.rotatedBrakeReleaseSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.driveTechnologiesManual.rotatedBrakeReleaseSelection[firstIndex_whichMeetConditions];
                        }
                    }
                    return null;
                },
                set(value) {
                    this.change_Selected_atElementOf_rotatedBrakeRelease(value);
                }
            },
            continueButton_Disabled: {
                get() {
                    return this.$store.state.inputsManual.continueButton_Disabled;
                }
            },
        },

        created() {
            this.$store.commit('inputsManual/change_psg_storeMutation', false)
            if (this.$store.state.manualHome.kid == null) {
                router.push('../manualStep/ManualHome');
            }
            else {
                this.$store.dispatch('addOnPartModal/check_toDos_at_addOnPartModal_storeAction');
            }
        },

        methods: {
            ValueDecimalSeparator(value) {
                return (value != null) ? this.$get_decimalValueToLocaleString({ value: value, country: this.$store.state.configurations.language, }) : value;
            },
            closeAddOnPartModal(value) {
                if (value == true) {
                    this.$store.dispatch('inputsManual/checkIf_addOnParts_areValid_storeAction');
                }
                else {
                    router.push('../manualStep/ManualHome');
                }
                this.$store.commit('manualHome/change_technicalConfiguration_storeMutation', false);
            },
            showModalInputSelection(value) {
                this.$store.dispatch('inputsManual/change_showInputSelectionModal_storeAction', { value: true, component: value });
            },
            showModalRopeGuardSelection(value) {
                this.$store.dispatch('inputsManual/change_showRopeGuardSelectionModal_storeAction', value);
            },
            change_Selected_atElementOf_altRopeGuard() {
                this.$store.dispatch('ropeGuardManual/change_AltRopeGuard_storeAction', null);
            },
            change_Selected_atElementOf_adjustability(value) {
                this.$store.dispatch('ropeGuardManual/change_adjustability_configuration_storeAction', value);
            },
            change_Selected_atElementOf_thirdRopeGuard(value) {
                this.$store.dispatch('ropeGuardManual/change_thirdRopeGuard_configuration_storeAction', value);
            },
            change_Selected_atElementOf_deliverRope(value) {
                this.$store.dispatch('ropeGuardManual/change_deliverRope_configuration_storeAction', value);
            },
            change_Selected_atElementOf_tractionSheaveCover(value) {
                this.$store.dispatch('ropeGuardManual/change_tractionSheaveCover_configuration_storeAction', value);
            },
            change_Selected_atElementOf_ropeClamp(value) {
                this.$store.dispatch('ropeGuardManual/change_ropeClamp_configuration_storeAction', value);
            },
            change_Selected_atElementOf_rescueReturnDevice(value) {
                this.$store.dispatch('ropeGuardManual/change_rescueReturnDevice_configuration_storeAction', value);
            },
            change_Selected_atElementOf_motorIP(value) {
                this.$store.dispatch('inputsManual/change_motorIP_configuration_storeAction', value);
            },
            change_Selected_atElementOf_bowdenwireDeliver(value) {
                this.$store.dispatch('inputsManual/change_bowdenwireDeliver_configuration_storeAction', value);
            },
            change_Selected_atElementOf_bowdenwireDetails(value) {
                this.$store.dispatch('inputsManual/change_bowdenwireDetails_configuration_storeAction', value);
            },
            change_Selected_atElementOf_brakeConnection(value) {
                this.$store.dispatch('inputsManual/change_brakeConnection_configuration_storeAction', value);
            },
            change_Selected_atElementOf_rotatedBrakeRelease(value) {
                this.$store.dispatch('driveTechnologiesManual/change_rotatedBrakeRelease_configuration_storeAction', value);
            },
            change_Selected_atElementOf_altLseils(value, event) {
                const isChecked = event.target.checked;
                this.$store.commit('ropeGuardManual/change_altLseilsSelectedCode_storeMutation', (isChecked) ? Number(value) : 0)
            },
            change_Selected_atElementOf_altLtsabd(value, event) {
                const isChecked = event.target.checked;
                this.$store.commit('ropeGuardManual/change_altLtsabdSelectedCode_storeMutation', (isChecked) ? Number(value) : 0)
            },
            change_Selected_atElementOf_altLtklem(value, event) {
                const isChecked = event.target.checked;
                if (!isChecked && this.altLruevSelectedCode != null) {
                    this.$store.commit('ropeGuardManual/change_altLruevSelectedCode_storeMutation', null)
                }
                this.$store.commit('ropeGuardManual/change_altLtklemSelectedCode_storeMutation', (isChecked) ? Number(value) : 0)
            },
            change_Selected_atElementOf_altLruev(value, event) {
                const isChecked = event.target.checked;
                this.$store.commit('ropeGuardManual/change_altLruevSelectedCode_storeMutation', (isChecked) ? Number(value) : 0)
            },

        },
    }
</script>


<style>
    .my_inputCheckboxSelected {
        border: none !important;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

    .my_inputCheckbox2 {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox2 li {
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

    .my_inputCheckbox {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox li {
            display: inline-block;
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

            .my_inputCheckbox li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_inputCheckbox li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }
</style>
